(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["assessment-dosha"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.mm-dosha[data-storage-key="marcela-dosha-test"]');
  if(!root||root.dataset.initialized==='true')return;
  root.dataset.initialized='true';

  var DATA=JSON.parse(root.querySelector('[data-dosha-data]').textContent);
  var groupsEl=root.querySelector('[data-groups]');
  var STORAGE_KEY=root.dataset.storageKey;
  var RETENTION_MS=20*24*60*60*1000;
  var createdAt=null;
  var names={k:'Kapha',p:'Pitta',v:'Vata'};
  var dirs=['k','p','v'];
  var saveTimer,statusTimer;
  var nameField=root.querySelector('[data-send-name]');
  var emailField=root.querySelector('[data-send-email]');

  function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML}

  function render(){
    var rowNo=0,html='';
    DATA.forEach(function(group,gi){
      html+='<section class="mm-dosha__group" data-group="'+(gi+1)+'">';
      html+='<div class="mm-dosha__group-title">Part '+(gi+1)+' of 4</div>';
      html+='<div class="mm-dosha__head"><div>Characteristic</div><div>Kapha</div><div>Pitta</div><div>Vata</div></div>';
      group.forEach(function(r){
        rowNo++;
        html+='<div class="mm-dosha-row" data-row="'+rowNo+'">';
        html+='<div class="mm-dosha-row__char">'+esc(r.characteristic)+'</div>';
        [['k','kapha'],['p','pitta'],['v','vata']].forEach(function(pair){
          html+='<label class="mm-dosha-option"><span class="mm-dosha-option__name">'+names[pair[0]]+'</span><span class="mm-dosha-option__text">'+esc(r[pair[1]])+'</span><input type="number" inputmode="numeric" min="0" max="3" step="1" data-g="'+(gi+1)+'" data-d="'+pair[0]+'" data-row="'+rowNo+'" aria-label="'+esc(r.characteristic+' '+pair[0]+rowNo)+'"></label>';
        });
        html+='</div>';
      });
      html+='<div class="mm-dosha__subtotal"><span>Subtotal, part '+(gi+1)+'</span>';
      html+='<div><em>Kapha</em><strong data-sub="'+(gi+1)+'-k">0</strong></div>';
      html+='<div><em>Pitta</em><strong data-sub="'+(gi+1)+'-p">0</strong></div>';
      html+='<div><em>Vata</em><strong data-sub="'+(gi+1)+'-v">0</strong></div>';
      html+='</div></section>';
    });
    groupsEl.innerHTML=html;
  }

  render();

  var inputs=Array.prototype.slice.call(root.querySelectorAll('.mm-dosha-option input'));

  function normalize(el){
    var raw=el.value.trim();
    if(raw==='')return null;
    var n=Number(raw);
    if(isNaN(n)){el.value='';return null}
    n=Math.max(0,Math.min(3,Math.round(n)));
    el.value=String(n);
    return n;
  }

  function recalc(){
    var tot={k:0,p:0,v:0},sub={1:{k:0,p:0,v:0},2:{k:0,p:0,v:0},3:{k:0,p:0,v:0},4:{k:0,p:0,v:0}};
    inputs.forEach(function(el){
      var v=normalize(el);
      el.classList.toggle('on',v!==null&&v>0);
      if(v===null)return;
      tot[el.dataset.d]+=v;
      sub[el.dataset.g][el.dataset.d]+=v;
    });

    for(var g=1;g<=4;g++){
      dirs.forEach(function(d){
        var el=root.querySelector('[data-sub="'+g+'-'+d+'"]');
        if(el)el.textContent=sub[g][d];
      });
    }

    var best=Math.max(tot.k,tot.p,tot.v);
    dirs.forEach(function(d){
      root.querySelector('[data-total="'+d+'"]').textContent=tot[d];
      root.querySelector('[data-bar="'+d+'"]').textContent=tot[d];
      root.querySelector('[data-card="'+d+'"]').classList.toggle('lead',best>0&&tot[d]===best);
      var bar=root.querySelector('[data-bar="'+d+'"]').parentElement;
      bar.classList.toggle('lead',best>0&&tot[d]===best);
    });

    var done=0;
    for(var r=1;r<=77;r++){
      if(inputs.some(function(el){return el.dataset.row===String(r)&&el.value!==''}))done++;
    }
    root.querySelector('[data-progress]').textContent=done+' of 77 answered';

    var leaders=[];
    dirs.forEach(function(d){if(best>0&&tot[d]===best)leaders.push(names[d])});
    var verdict=root.querySelector('[data-verdict]');

    if(best===0){
      verdict.textContent='Start scoring and your result will appear here.';
    }else if(leaders.length>1){
      verdict.textContent='Your highest scores are tied between '+leaders.join(' and ')+'. A dual constitution is common, and we will look at it together.';
    }else{
      var sorted=[tot.k,tot.p,tot.v].sort(function(a,b){return b-a});
      var close=(sorted[0]-sorted[1])<=10;
      verdict.textContent='Your highest score is '+leaders[0]+'.'+
        (close?' Your second score is close behind, which often means a dual constitution.':'')+
        (done<77?' You have '+(77-done)+' rows left.':'');
    }

    window.__mmDoshaTotals=tot;
  }

  function save(){
    try{
      if(!createdAt)createdAt=Date.now();
      var values={__createdAt:createdAt};
      inputs.forEach(function(el){if(el.value!=='')values[el.getAttribute('aria-label')]=el.value});
      if(nameField&&nameField.value)values.__sendName=nameField.value;
      if(emailField&&emailField.value)values.__sendEmail=emailField.value;
      localStorage.setItem(STORAGE_KEY,JSON.stringify(values));
      var s=root.querySelector('[data-save-status]');
      s.textContent='Saved on this device';
      clearTimeout(statusTimer);
      statusTimer=setTimeout(function(){s.textContent=''},2200);
    }catch(e){}
  }

  function scheduleSave(){clearTimeout(saveTimer);saveTimer=setTimeout(save,400)}

  function restore(){
    try{
      var raw=localStorage.getItem(STORAGE_KEY);
      if(!raw)return;
      var values=JSON.parse(raw);
      var savedAt=parseInt(values.__createdAt||0,10);
      if(savedAt&&Date.now()-savedAt>=RETENTION_MS){localStorage.removeItem(STORAGE_KEY);createdAt=null;return;}
      createdAt=savedAt||Date.now();
      if(!savedAt){values.__createdAt=createdAt;localStorage.setItem(STORAGE_KEY,JSON.stringify(values));}
      inputs.forEach(function(el){
        var key=el.getAttribute('aria-label');
        if(values[key]!=null)el.value=values[key];
      });
      if(nameField&&values.__sendName)nameField.value=values.__sendName;
      if(emailField&&values.__sendEmail)emailField.value=values.__sendEmail;
    }catch(e){}
  }

  inputs.forEach(function(el){
    el.addEventListener('input',function(){recalc();scheduleSave()});
    el.addEventListener('keydown',function(e){
      if(e.key==='Enter'){
        var i=inputs.indexOf(el);
        if(inputs[i+3]){inputs[i+3].focus();e.preventDefault()}
      }
    });
  });

  if(nameField)nameField.addEventListener('input',scheduleSave);
  if(emailField)emailField.addEventListener('input',scheduleSave);

  var contactForm=root.querySelector('#mm-dosha-contact');
  if(contactForm){
    contactForm.addEventListener('submit',function(){
      var tot=window.__mmDoshaTotals||{k:0,p:0,v:0};
      var best=Math.max(tot.k,tot.p,tot.v);
      var leaders=[];
      dirs.forEach(function(d){if(best>0&&tot[d]===best)leaders.push(names[d])});
      var result=best===0?'Not started':(leaders.length>1?'Tie: '+leaders.join(' and '):leaders[0]);
      var lines=['ASSESSMENT: DOSHA',''];
      lines.push('Name: '+(nameField?nameField.value:''));
      lines.push('Email: '+(emailField?emailField.value:''));
      lines.push('Submitted: '+new Date().toLocaleString('en-US',{dateStyle:'long',timeStyle:'short'}));
      lines.push('','RESULT');
      lines.push('Kapha: '+tot.k);
      lines.push('Pitta: '+tot.p);
      lines.push('Vata: '+tot.v);
      lines.push('Profile: '+result,'','ROWS','');

      root.querySelectorAll('.mm-dosha-row').forEach(function(row){
        var characteristic=row.querySelector('.mm-dosha-row__char').textContent.trim();
        lines.push(characteristic);
        row.querySelectorAll('.mm-dosha-option').forEach(function(option){
          var n=option.querySelector('.mm-dosha-option__name').textContent.trim();
          var t=option.querySelector('.mm-dosha-option__text').textContent.trim();
          var input=option.querySelector('input');
          lines.push(n+' — '+t+': '+(input.value!==''?input.value:'Not answered'));
        });
        lines.push('');
      });

      var hiddenName=root.querySelector('[data-contact-name]');
      var bodyField=root.querySelector('[data-contact-body]');
      if(hiddenName)hiddenName.value=nameField&&nameField.value?nameField.value:'Assessment client';
      if(bodyField)bodyField.value=lines.join('\n');
      save();
    });
  }

  root.querySelector('[data-print]').addEventListener('click',function(){save();window.print()});
  root.querySelector('[data-clear]').addEventListener('click',function(){
    if(!window.confirm('Clear every answer on this page?'))return;
    inputs.forEach(function(el){el.value=''});
    if(nameField)nameField.value='';
    if(emailField)emailField.value='';
    try{localStorage.removeItem(STORAGE_KEY)}catch(e){}
    createdAt=null;
    recalc();
    window.scrollTo({top:0,behavior:'smooth'});
  });

  restore();
  recalc();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["assessment-food-journal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[id^="mm-meal-"]'));

  roots.forEach(function (root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

  var STORAGE_KEY = root.dataset.storageKey;
  var RETENTION_MS = 20 * 24 * 60 * 60 * 1000;
  var createdAt = null;
  var textFields = Array.prototype.slice.call(root.querySelectorAll('[data-sync-key]'));
  var waterFields = Array.prototype.slice.call(root.querySelectorAll('[data-water-key]'));
  var singleFields = Array.prototype.slice.call(root.querySelectorAll('[data-single-key]'));
  var progressEl = root.querySelector('[data-progress]');
  var saveStatusEl = root.querySelector('[data-save-status]');
  var saveTimer = null;
  var statusTimer = null;
  var syncing = false;

  function groupedByKey(fields, attr) {
    var map = {};
    fields.forEach(function (field) {
      var key = field.getAttribute(attr);
      if (!map[key]) map[key] = [];
      map[key].push(field);
    });
    return map;
  }

  var textGroups = groupedByKey(textFields, 'data-sync-key');
  var waterGroups = groupedByKey(waterFields, 'data-water-key');

  function syncText(source) {
    if (syncing) return;
    syncing = true;
    var key = source.dataset.syncKey;
    (textGroups[key] || []).forEach(function (field) {
      if (field !== source) field.value = source.value;
    });
    syncing = false;
  }

  function syncWater(source) {
    if (syncing) return;
    syncing = true;
    var key = source.dataset.waterKey;
    (waterGroups[key] || []).forEach(function (field) {
      if (field !== source) field.checked = source.checked;
    });
    syncing = false;
  }

  function canonicalTextValue(key) {
    var fields = textGroups[key] || [];
    return fields.length ? fields[0].value.trim() : '';
  }

  function canonicalWaterValue(key) {
    var fields = waterGroups[key] || [];
    return fields.length ? fields[0].checked : false;
  }

  function getSingleValue(key) {
    var matches = singleFields.filter(function (field) {
      return field.dataset.singleKey === key;
    });

    if (!matches.length) return '';

    if (matches[0].type === 'radio') {
      var checked = matches.find(function (field) { return field.checked; });
      return checked ? checked.value : '';
    }

    if (matches[0].type === 'checkbox') {
      return matches[0].checked ? matches[0].value : '';
    }

    return matches[0].value || '';
  }

  function countWater(dayKey) {
    var count = 0;
    for (var n = 1; n <= 8; n += 1) {
      if (canonicalWaterValue(dayKey + '_water_' + n)) count += 1;
    }
    return count;
  }

  function updateProgress() {
    var keys = Object.keys(textGroups).filter(function (key) {
      return key !== 'week' &&
        key !== 'notes' &&
        key !== 'send_name' &&
        key !== 'send_email';
    });

    var filled = keys.filter(function (key) {
      return canonicalTextValue(key) !== '';
    }).length;

    var waterDays = ['mon','tue','wed','thu','fri','sat','sun'].filter(function (day) {
      return countWater(day) > 0;
    }).length;

    progressEl.textContent = (filled + waterDays) + ' entries filled in';
  }

  function collect() {
    if (!createdAt) createdAt = Date.now();
    var data = {
      __createdAt: createdAt,
      text: {},
      water: {},
      single: {}
    };

    Object.keys(textGroups).forEach(function (key) {
      data.text[key] = canonicalTextValue(key);
    });

    Object.keys(waterGroups).forEach(function (key) {
      data.water[key] = canonicalWaterValue(key);
    });

    singleFields.forEach(function (field) {
      data.single[field.dataset.singleKey] = getSingleValue(field.dataset.singleKey);
    });

    return data;
  }

  function save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(collect()));

      if (saveStatusEl) {
        saveStatusEl.textContent = 'Saved on this device';
        clearTimeout(statusTimer);
        statusTimer = setTimeout(function () {
          saveStatusEl.textContent = '';
        }, 2200);
      }
    } catch (error) {}
  }

  function scheduleSave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(save, 500);
  }

  function restore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      var savedAt = parseInt(data.__createdAt || 0, 10);
      if (savedAt && Date.now() - savedAt >= RETENTION_MS) {
        localStorage.removeItem(STORAGE_KEY);
        createdAt = null;
        return;
      }
      createdAt = savedAt || Date.now();
      if (!savedAt) {
        data.__createdAt = createdAt;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      }

      Object.keys(data.text || {}).forEach(function (key) {
        (textGroups[key] || []).forEach(function (field) {
          field.value = data.text[key] || '';
        });
      });

      Object.keys(data.water || {}).forEach(function (key) {
        (waterGroups[key] || []).forEach(function (field) {
          field.checked = !!data.water[key];
        });
      });

      Object.keys(data.single || {}).forEach(function (key) {
        singleFields.forEach(function (field) {
          if (field.dataset.singleKey !== key) return;

          if (field.type === 'radio') {
            field.checked = field.value === data.single[key];
          } else if (field.type === 'checkbox') {
            field.checked = data.single[key] === field.value;
          } else {
            field.value = data.single[key] || '';
          }
        });
      });
    } catch (error) {}
  }

  function clearAll() {
    if (!window.confirm('Clear the whole meal planner and start over?')) return;

    textFields.forEach(function (field) { field.value = ''; });
    waterFields.forEach(function (field) { field.checked = false; });
    singleFields.forEach(function (field) {
      if (field.type === 'checkbox' || field.type === 'radio') field.checked = false;
      else field.value = '';
    });

    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
    createdAt = null;

    if (saveStatusEl) saveStatusEl.textContent = '';
    updateProgress();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  textFields.forEach(function (field) {
    field.addEventListener('input', function () {
      syncText(field);
      updateProgress();
      scheduleSave();
    });
  });

  waterFields.forEach(function (field) {
    field.addEventListener('change', function () {
      syncWater(field);
      updateProgress();
      scheduleSave();
    });
  });

  singleFields.forEach(function (field) {
    field.addEventListener('change', scheduleSave);
  });

  var printButton = root.querySelector('[data-print]');
  if (printButton) {
    printButton.addEventListener('click', function () {
      save();
      window.print();
    });
  }

  var clearButton = root.querySelector('[data-clear]');
  if (clearButton) {
    clearButton.addEventListener('click', clearAll);
  }

  var form = root.querySelector('#mm-meal-contact');

  if (form) {
    form.addEventListener('submit', function () {
      var lines = [];
      var days = [
        ['mon', 'Monday'],
        ['tue', 'Tuesday'],
        ['wed', 'Wednesday'],
        ['thu', 'Thursday'],
        ['fri', 'Friday'],
        ['sat', 'Saturday'],
        ['sun', 'Sunday']
      ];

      lines.push('ASSESSMENT: MEAL PLANNER');
      lines.push('');
      lines.push('Name: ' + canonicalTextValue('send_name'));
      lines.push('Email: ' + canonicalTextValue('send_email'));
      lines.push('Submitted: ' + new Date().toLocaleString('en-US',{dateStyle:'long',timeStyle:'short'}));
      lines.push('Week of: ' + canonicalTextValue('week'));
      lines.push('');
      lines.push('GOALS');
      lines.push('Eat raw: ' + (getSingleValue('raw_goal') ? getSingleValue('raw_goal') + '%' : 'Not selected'));
      lines.push('Chew well: ' + (getSingleValue('habit_chew') ? 'Yes' : 'No'));
      lines.push('Drink pure water: ' + (getSingleValue('habit_water') ? 'Yes' : 'No'));
      lines.push('Laugh & love: ' + (getSingleValue('habit_love') ? 'Yes' : 'No'));
      lines.push('');

      days.forEach(function (day) {
        var key = day[0];
        var label = day[1];

        lines.push('--- ' + label.toUpperCase() + ' ---');
        lines.push('Breakfast: ' + (canonicalTextValue(key + '_breakfast') || 'Not answered'));
        lines.push('Lunch: ' + (canonicalTextValue(key + '_lunch') || 'Not answered'));
        lines.push('Dinner: ' + (canonicalTextValue(key + '_dinner') || 'Not answered'));
        lines.push('Snacks / Dessert: ' + (canonicalTextValue(key + '_snacks') || 'Not answered'));
        lines.push('Water: ' + countWater(key) + ' of 8 glasses');
        lines.push('Move my body: ' + (canonicalTextValue(key + '_move') || 'Not answered'));
        lines.push('');
      });

      lines.push('NOTES');
      lines.push(canonicalTextValue('notes') || 'Not answered');

      var hiddenName = root.querySelector('[data-contact-name]');
      var body = root.querySelector('[data-contact-body]');

      if (hiddenName) {
        hiddenName.value = canonicalTextValue('send_name') || 'Meal Planner client';
      }

      if (body) {
        body.value = lines.join('\n');
      }

      save();
    });
  }

    restore();
    updateProgress();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["assessment-health"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.mm-health[data-storage-key="marcela-health-questionnaire"]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var STORAGE_KEY = root.dataset.storageKey;
  var RETENTION_MS = 20 * 24 * 60 * 60 * 1000;
  var createdAt = null;
  var fields = Array.prototype.slice.call(root.querySelectorAll('[data-field-key]'));
  var progressEl = root.querySelector('[data-progress]');
  var saveStatusEl = root.querySelector('[data-save-status]');
  var saveTimer = null;
  var statusTimer = null;
  var nameField = root.querySelector('[data-send-name]');
  var emailField = root.querySelector('[data-send-email]');

  function progress() {
    var done = fields.filter(function (field) { return field.value.trim() !== ''; }).length;
    progressEl.textContent = done + ' of ' + fields.length + ' answered';
  }

  function collect() {
    if (!createdAt) createdAt = Date.now();
    var data = { __createdAt: createdAt };
    fields.forEach(function (field) { if (field.value.trim() !== '') data[field.dataset.fieldKey] = field.value; });
    if (nameField && nameField.value.trim() !== '') data.__sendName = nameField.value;
    if (emailField && emailField.value.trim() !== '') data.__sendEmail = emailField.value;
    return data;
  }

  function save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(collect()));
      saveStatusEl.textContent = 'Saved on this device';
      clearTimeout(statusTimer);
      statusTimer = setTimeout(function () { saveStatusEl.textContent = ''; }, 2200);
    } catch (error) {}
  }

  function restore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      var savedAt = parseInt(data.__createdAt || 0, 10);
      if (savedAt && Date.now() - savedAt >= RETENTION_MS) {
        localStorage.removeItem(STORAGE_KEY);
        createdAt = null;
        return;
      }
      createdAt = savedAt || Date.now();
      if (!savedAt) {
        data.__createdAt = createdAt;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      }
      fields.forEach(function (field) {
        var key = field.dataset.fieldKey;
        if (data[key] != null) field.value = data[key];
      });
      if (nameField && data.__sendName) nameField.value = data.__sendName;
      if (emailField && data.__sendEmail) emailField.value = data.__sendEmail;
    } catch (error) {}
  }

  function scheduleSave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(save, 600);
  }

  function clearAll() {
    if (!window.confirm('Clear every answer and start over?')) return;
    fields.forEach(function (field) { field.value = ''; });
    if (nameField) nameField.value = '';
    if (emailField) emailField.value = '';
    try { localStorage.removeItem(STORAGE_KEY); } catch (error) {}
    createdAt = null;
    saveStatusEl.textContent = '';
    progress();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  fields.forEach(function (field) {
    field.addEventListener('input', function () { progress(); scheduleSave(); });
  });
  if (nameField) nameField.addEventListener('input', scheduleSave);
  if (emailField) emailField.addEventListener('input', scheduleSave);

  var printButton = root.querySelector('[data-print]');
  if (printButton) printButton.addEventListener('click', function () { save(); window.print(); });

  var clearButton = root.querySelector('[data-clear]');
  if (clearButton) clearButton.addEventListener('click', clearAll);

  var form = root.querySelector('#mm-health-contact');
  if (form) {
    form.addEventListener('submit', function () {
      var lines = ['ASSESSMENT: HEALTH QUESTIONNAIRE', ''];
      lines.push('Name: ' + (nameField ? nameField.value : ''));
      lines.push('Email: ' + (emailField ? emailField.value : ''));
      lines.push('Submitted: ' + new Date().toLocaleString('en-US',{dateStyle:'long',timeStyle:'short'}));
      lines.push('');

      fields.forEach(function (field) {
        var label = field.labels && field.labels.length ? field.labels[0].textContent.trim() : field.dataset.fieldKey;
        lines.push(label);
        lines.push(field.value.trim() || 'Not answered');
        lines.push('');
      });

      var hiddenEmail = root.querySelector('[data-contact-email]');
      var hiddenName = root.querySelector('[data-contact-name]');
      var body = root.querySelector('[data-contact-body]');
      if (hiddenEmail) hiddenEmail.value = emailField && emailField.value ? emailField.value : '';
      if (hiddenName) hiddenName.value = nameField && nameField.value ? nameField.value : 'Assessment client';
      if (body) body.value = lines.join('\n');
      save();
    });
  }

  restore();
  progress();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["assessment-oxidizer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.mm-oxidizer[data-storage-key="marcela-oxidizer-profile"]');
  if(!root||root.dataset.initialized==='true')return;
  root.dataset.initialized='true';

  var KEY=root.dataset.storageKey;
  var RETENTION_MS=20*24*60*60*1000;
  var createdAt=null;
  var radios=[].slice.call(root.querySelectorAll('input[type="radio"]'));
  var nameField=root.querySelector('[data-save-field="name"]');
  var emailField=root.querySelector('[data-contact-email]');
  var progressEl=root.querySelector('[data-progress]');
  var verdictEl=root.querySelector('[data-verdict]');
  var detailEl=root.querySelector('[data-result-detail]');
  var saveStatus=root.querySelector('[data-save-status]');
  var saveTimer,statusTimer;

  function group(name){
    var names={},yes=0,answered=0;
    radios.forEach(function(r){
      if(r.dataset.group!==name)return;
      names[r.name]=1;
      if(r.checked){answered++;if(r.value==='1')yes++}
    });
    return {total:Object.keys(names).length,yes:yes,answered:answered};
  }

  function setAll(selector,value){
    root.querySelectorAll(selector).forEach(function(el){el.textContent=value});
  }

  function profile(){
    var s=group('slow'),f=group('fast');
    var done=s.answered+f.answered,total=s.total+f.total;
    if(!done)return 'Not started';
    var sp=s.answered?s.yes/s.answered:0,fp=f.answered?f.yes/f.answered:0;
    var gap=Math.abs(sp-fp),lead=sp>fp?'Slow Oxidizer':'Fast Oxidizer';
    if(done<total)return 'Leaning '+lead;
    if(gap<0.10)return 'Mixed Oxidizer';
    return lead;
  }

  function recalc(){
    var s=group('slow'),f=group('fast');
    var done=s.answered+f.answered,total=s.total+f.total;
    setAll('[data-slow-total],[data-result-slow],[data-bar-slow]',s.yes);
    setAll('[data-fast-total],[data-result-fast],[data-bar-fast]',f.yes);
    progressEl.textContent=done+' of '+total+' answered';

    if(!done){
      verdictEl.textContent='Answer the questions above';
      detailEl.textContent='Your two scores appear here as you go.';
      return;
    }

    var sp=s.answered?s.yes/s.answered:0,fp=f.answered?f.yes/f.answered:0;
    var gap=Math.abs(sp-fp),lead=sp>fp?'Slow Oxidizer':'Fast Oxidizer';

    if(done<total){
      verdictEl.textContent='Leaning '+lead;
      detailEl.textContent='Still '+(total-done)+' to answer. Finish both halves for a reliable reading.';
    }else if(gap<0.10){
      verdictEl.textContent='Mixed Oxidizer';
      detailEl.textContent='Your two halves came out close together, which is its own answer. Slow '+s.yes+' of '+s.answered+', Fast '+f.yes+' of '+f.answered+'.';
    }else{
      verdictEl.textContent=lead;
      detailEl.textContent='Slow '+s.yes+' of '+s.answered+', Fast '+f.yes+' of '+f.answered+'. The clearer the gap, the more strongly this type applies to you.';
    }
  }

  function data(){
    if(!createdAt)createdAt=Date.now();
    var o={answers:{},name:nameField?nameField.value:'',email:emailField?emailField.value:'',__createdAt:createdAt};
    radios.forEach(function(r){if(r.checked)o.answers[r.name]=r.value});
    return o;
  }

  function save(){
    try{
      localStorage.setItem(KEY,JSON.stringify(data()));
      if(saveStatus){
        saveStatus.textContent='Saved on this device';
        clearTimeout(statusTimer);
        statusTimer=setTimeout(function(){saveStatus.textContent=''},2200);
      }
    }catch(e){}
  }

  function restore(){
    try{
      var raw=localStorage.getItem(KEY);if(!raw)return;
      var o=JSON.parse(raw);
      var savedAt=parseInt(o.__createdAt||0,10);
      if(savedAt&&Date.now()-savedAt>=RETENTION_MS){localStorage.removeItem(KEY);createdAt=null;return;}
      createdAt=savedAt||Date.now();
      if(!savedAt){o.__createdAt=createdAt;localStorage.setItem(KEY,JSON.stringify(o));}
      Object.keys(o.answers||{}).forEach(function(n){
        radios.forEach(function(r){if(r.name===n&&r.value===o.answers[n])r.checked=true});
      });
      if(nameField&&o.name)nameField.value=o.name;
      if(emailField&&o.email)emailField.value=o.email;
    }catch(e){}
  }

  function schedule(){clearTimeout(saveTimer);saveTimer=setTimeout(save,500)}

  radios.forEach(function(r){r.addEventListener('change',function(){recalc();schedule()})});
  if(nameField)nameField.addEventListener('input',schedule);
  if(emailField)emailField.addEventListener('input',schedule);

  var printBtn=root.querySelector('[data-print]');
  if(printBtn)printBtn.addEventListener('click',function(){save();window.print()});

  var clearBtn=root.querySelector('[data-clear]');
  if(clearBtn)clearBtn.addEventListener('click',function(){
    if(!confirm('Clear every answer and start over?'))return;
    radios.forEach(function(r){r.checked=false});
    if(nameField)nameField.value='';
    if(emailField)emailField.value='';
    try{localStorage.removeItem(KEY)}catch(e){}
    createdAt=null;
    recalc();
    window.scrollTo({top:0,behavior:'smooth'});
  });

  var form=root.querySelector('#mm-oxidizer-contact');
  if(form)form.addEventListener('submit',function(){
    var s=group('slow'),f=group('fast'),lines=[];
    lines.push('ASSESSMENT: OXIDIZER PROFILE','');
    lines.push('Name: '+(nameField?nameField.value:''));
    lines.push('Email: '+(emailField?emailField.value:''));
    lines.push('Submitted: '+new Date().toLocaleString('en-US',{dateStyle:'long',timeStyle:'short'}));
    lines.push('','RESULT');
    lines.push('Slow: '+s.yes+' of '+s.answered);
    lines.push('Fast: '+f.yes+' of '+f.answered);
    lines.push('Profile: '+profile(),'','ANSWERS','');

    var si=0,fi=0;
    root.querySelectorAll('[data-question]').forEach(function(q){
      var part=q.dataset.part;
      var n=part==='slow'?'Slow '+(++si):'Fast '+(++fi);
      var text=q.querySelector('.mm-oxidizer-question__text').textContent.trim();
      var checked=q.querySelector('input[type="radio"]:checked');
      lines.push(n+'. '+text);
      lines.push(checked?(checked.value==='1'?'Yes':'No'):'Not answered','');
    });

    root.querySelector('[data-contact-body]').value=lines.join('\n');
    root.querySelector('[data-contact-name]').value=(nameField&&nameField.value)?nameField.value:'Assessment client';
    save();
  });

  restore();
  recalc();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const menuBtn = document.getElementById('menuBtn');
  const drawer = document.getElementById('mobileDrawer');
  const overlay = document.getElementById('drawerOverlay');
  const closeBtn = document.getElementById('drawerClose');

  let lastFocused = null;

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('open');
    overlay.classList.add('active');
    drawer.removeAttribute('inert');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
    drawer.setAttribute('inert', '');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  menuBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  drawer.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });

  // Focus trap while the drawer is open
  drawer.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') return;
    const f = drawer.querySelectorAll('a[href], button:not([disabled])');
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Desktop nav dropdowns — hover-intent with a close delay so the menu stays
  // open long enough to move the cursor down and choose (per Marcela 2026-07-18).
  (function () {
    var CLOSE_DELAY = 380; // ms grace period before a hovered menu closes
    var items = document.querySelectorAll('.header__inline-nav .has-dropdown, .header__inline-nav .has-mega');
    items.forEach(function (item) {
      var timer = null;
      function open() { clearTimeout(timer); item.classList.add('is-open'); }
      function scheduleClose() {
        clearTimeout(timer);
        timer = setTimeout(function () { item.classList.remove('is-open'); }, CLOSE_DELAY);
      }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      // Keyboard: keep it open while focus is inside, close shortly after leaving.
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose();
      });
      // Esc closes immediately.
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { clearTimeout(timer); item.classList.remove('is-open'); }
      });
    });
  })();

  // Cream at top, white on scroll (per Marcela — matches her current site)
  (function () {
    var wrap = document.querySelector('.header-wrapper');
    if (!wrap) return;
    function onScroll() {
      if (window.scrollY > 24) wrap.classList.add('is-scrolled');
      else wrap.classList.remove('is-scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  // Boutique nav items stay hidden until the visitor has opted in
  // (see snippets/boutique-optin-gate.liquid) — per Marcela, 2026-09-13.
  if (document.cookie.indexOf('mb_boutique_unlock=1') !== -1) {
    document.querySelectorAll('[data-mb-gate="boutique"]').forEach(function (el) {
      el.style.display = el.tagName === 'LI' ? 'list-item' : 'block';
    });
  }

  } catch(e) { console.error(e); }
})();
})();
